/**
 * Adds or replaces a booking in a list and keeps it in the order the server
 * returns it in (by its time, ascending). Without this a new or re-dated flight
 * stayed wherever it was pushed until the tab was reloaded.
 */
export function upsertByTime<T extends { id: string }>(list: T[], item: T, timeOf: (x: T) => string): T[] {
  const next = list.some(x => x.id === item.id)
    ? list.map(x => (x.id === item.id ? item : x))
    : [...list, item];
  return next.sort((a, b) => Date.parse(timeOf(a)) - Date.parse(timeOf(b)));
}
